import _ from "lodash";
import { observer } from "mobx-react";
import moment from "moment";
import Papa from "papaparse";
import React, { SyntheticEvent, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { FormattedMessage } from "react-intl";
import SlidingPanel from "react-sliding-side-panel";
import no_user from "../../../assets/Images/svg/no-user.svg";
import TerminationTypeEnum from "../../../constants/termination-type-enum";
import {
  DATE_TIME_FORMAT_FILENAME,
  DATE_TIME_FORMAT_WITHOUT_SECONDS,
  emptyValueHyphen,
} from "../../../constants/common-constants";
import fotaFileTypeEnum from "../../../constants/fota-file-type-enum";
import FotaStatusEnum from "../../../constants/fota-status-enum";
import systemModuleEnum from "../../../constants/system-module-enum";
import userSettingEnum from "../../../constants/user-setting-enum";
import { useStore } from "../../../contexts/StoreProvider";
import {
  isOperationPermitted,
  showIcons,
} from "../../../helpers/action-permission-helper";
import config from "../../../helpers/config-helper";
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from "../../../models/ICommon";
import { IFotaDeviceStatusParentData, IFotaHostScheduleList } from "../../../models/response/IFotaNewResponse";
import { IFotaDevicesStatusList } from "../../../models/response/IFotaSchedulerDevicesResponse";
import LoaderButton from "../../../shared-components/Button/LoaderButton";
import LoaderIconButton from "../../../shared-components/Button/LoaderIconButton";
import FormLoader from "../../../shared-components/FormLoader/FormLoader";
import Grid from "../../../shared-components/Grid/Grid";
import Pagination from "../../../shared-components/Grid/Pagination";
import FilterPopupHOC from "../../../shared-components/popup/filter/filter-popup-hoc";
import RoutesConstants from "../../../shared-components/Routes/routes.constants";
import { formatMessage } from "../../../translations/format-message";
import FotaDeviceStatusFilterForm from "../forms/fota-device-status-filter-form";
import AbortPopupHOC from "../../../shared-components/popup/abort/abort-popup-hoc";
import { faBan, faMicrochip, faPencilAlt, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import DeletePopup from "../../../shared-components/popup/delete/delete-popup";
import { ActionFormatter } from "../../../shared-components/Grid/GridFormatter";
import ConfirmPopupHOC from "../../../shared-components/popup/confirm/confirm-popup-hoc";
import CantAbortIconSVG from "../../../shared-components/svg/cant-abort";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AbortIconSVG from "../../../shared-components/svg/abort";
import DisableAbortIconSVG from "../../../shared-components/svg/disable-abort";
import FotaDeviceStatusDetails from "./fota-device-status-detail";
import fotaTntReleaseStore from "../../../core/stores/fota-tnt-release-store";
import fotaViewTypeEnum, { ModuleToOpen } from "../../../constants/fota-view-type-enum";
import { getUserTypeFromLocalStorage } from "../../../helpers/local-stotrage-helper";
import userTypeEnum from "../../../constants/user-type-enum";

const FotaSchedulerDeviceStatus = (props: any) => {
  const { preferencesStore, schedulerHistoryStore, fotaStore } = useStore();
  const {
    error,
    schedulerDeviceStatusListState,
    reset,
    GetFotaSchedulerDeviceStatusListService,
    getFotaSchedulerDeviceStatusList,
    resetSchedulerDeviceStatusListState,
    schedulerDeviceStatusList,
    resetStore,
    filterDetails,
    setFilterDetail,
    resetAbortSelectedDeviceScheduleState,
    abortSelectedDeviceScheduleState,
    AbortFotaDeviceScheduleByDeviceListService,
    DeleteFotaDeviceScheduleService,
    resetDeleteFotaDeviceScheduleState,
    deleteFotaDeviceScheduleState,
  } = schedulerHistoryStore;
  const {
    userSetting,
    setUserSetting,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;
  const { setSelectedView, isSelectedView } = fotaTntReleaseStore;
  const pageLimitOptions: Array<number> = [10, 50, 100, 1000];
  const [selectedId, setSelectedId] = useState<number>(0);
  const [selectedRow, setSelectedRow] = useState<null | IFotaDevicesStatusList>(null);
  const [selectedDevices, setSelectedDevices] = useState<
    Array<IFotaDevicesStatusList>
  >([]);
  const [openPanel, setOpenPanel] = useState(false);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.fotaLimitConfig,
    isPageLimitChange: false,
  });

  const getSelectedViewEnum = () => {
    switch (isSelectedTabView) {
      case fotaViewTypeEnum.Host:
        return fotaViewTypeEnum.Host;
      case fotaViewTypeEnum.Modem:
        return fotaViewTypeEnum.Modem;
      case fotaViewTypeEnum.Jet:
        return fotaViewTypeEnum.Jet;
      default:
        return fotaViewTypeEnum.Host;
    }
  }

  //Deepak Paliwal: Retain Tab position same when view fota selected tab 's devices status
  const setFotaTabTypeAndRoute = () => {
    if (getUserTypeFromLocalStorage() == userTypeEnum.TenantUser) {
      setSelectedView({ view: getSelectedViewEnum(), moduleToOpen: ModuleToOpen.Schedule, isViewChanged: true });
    }
    props.history.push(RoutesConstants.Fota);
  }

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });
  const selectedRecord: IFotaDeviceStatusParentData | null = props.location
    ?.state
    ? props.location.state.selectedRecord
    : null;
  const isSelectedTabView: fotaViewTypeEnum = props.location
    ?.state
    ? props.location.state.isSelectedTabView
    : null;
  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: schedulerDeviceStatusList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.FotaLimitConfig, parseInt(evt.target.value));
  };

  useEffect(() => {
    return (() => {
      setSelectedView({ view: (getUserTypeFromLocalStorage() == userTypeEnum.SystemUser ? fotaViewTypeEnum.Modem : fotaViewTypeEnum.Host), moduleToOpen: ModuleToOpen.Schedule, isViewChanged: false })
    })
  }, []);



  /**
   * This function calls the "GetFotaMzlReleaseListService" store funtion that get fota release list from API
   */
  const callGetFotaDeviceStatusListService = () => {
    if (selectedRecord?.Id)
      GetFotaSchedulerDeviceStatusListService(
        pageInfo.currentPage,
        pageLimitInfo.pageLimit,
        isSelectedTabView,
        selectedRecord.Id,
        filterDetails
      );
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "pageLimitInfo.pageLimit" of the useEffect changed.
   */
  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      callGetFotaDeviceStatusListService();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageLimitInfo.pageLimit]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "GroupList" of the useEffect changed.
   */
  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      totalPages: schedulerDeviceStatusList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getFotaSchedulerDeviceStatusList]);

  useEffect(() => {
    return () => {
      resetStore();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (filterDetails.isFilterActive) callGetFotaDeviceStatusListService();
    else {
      callGetFotaDeviceStatusListService();
    }
  }, [filterDetails]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "pageInfo.currentPage" of the useEffect changed.
   */
  useEffect(() => {
    if (pageInfo.isPagerChange) {
      callGetFotaDeviceStatusListService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "error" of the useEffect changed.
   */
  useEffect(() => {
    if (error) {
      toast.error(formatMessage(error));
      reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "deleteFotaSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (deleteFotaDeviceScheduleState.success) {
      resetDeleteFotaDeviceScheduleState();
      toast.success(formatMessage("deleted_success"));
      if (selectedId > 0) setSelectedId(-1);
      props.confirmPopupToggleHandler();
      if (
        selectedDevices.length >= pageLimitInfo.pageLimit ||
        (pageInfo.currentPage == pageInfo.totalPages &&
          selectedDevices.length >= getFotaSchedulerDeviceStatusList.length)
      ) {
        setPageInfo({
          ...pageInfo,
          currentPage: 1,
          isPagerChange: true,
          isRefreshPage: true,
        });
        if (
          pageInfo.currentPage == 1 &&
          selectedDevices.length == pageLimitInfo.pageLimit
        )
          callGetFotaDeviceStatusListService();
      } else {
        callGetFotaDeviceStatusListService();
      }
      setSelectedDevices([]);
      callGetFotaDeviceStatusListService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteFotaDeviceScheduleState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "deleteFotaSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (abortSelectedDeviceScheduleState.success) {
      toast.success(formatMessage("abort_success"));
      if (selectedId > 0) setSelectedId(-1);
      resetAbortSelectedDeviceScheduleState();
      props.abortPopupToggleHandler();
      setSelectedDevices([]);
      callGetFotaDeviceStatusListService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [abortSelectedDeviceScheduleState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "islanguageChanged" of the useEffect changed.
   */
  useEffect(() => {
    if (islanguageChanged) {
      callGetFotaDeviceStatusListService();
      updateLanguageChangedFlag();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [islanguageChanged]);

  function rowClassFormat(row: any, rowIdx: number) {
    let className: string = "";
    if (selectedId && row.Id === selectedId) {
      className = "bg-row SelectedRow";
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any, rowIndex: number) => {
    setSelectedId(row.Id);
    setSelectedRow(row);
    setOpenPanel(true);
  };

  const closePanelhandler = () => {
    setOpenPanel(false);
    setSelectedId(-1);
    setSelectedRow(null);
    // tenantStore.reset();
  };

  /**
   * This function provides manual refresh functionality
   * This function is used when we give refresh functionality to user.
   */
  const refreshClickHandler = () => {
    callGetFotaDeviceStatusListService();
  };

  //   const downloadCSVHandler = () => {
  //     callGetFotaDeviceStatusListService();
  //   };

  const downloadCSVHandler = () => {
    const currentDate = new Date();
    const deviceListToExport = getFotaSchedulerDeviceStatusList.map(
      (deviceStatus: IFotaDevicesStatusList) => {
        return {
          ICCID: deviceStatus.ICCID,
          ScheduleDate: selectedRecord?.ScheduleDate,
          ScheduleExpirationDate: selectedRecord?.ScheduleExpirationDate,
          Version: selectedRecord?.Version,
          TotalSegment: deviceStatus.TotalSegment,
          LastSegmentNoRequestedByDevice:
            deviceStatus.LastSegmentNoRequestedByDevice,
          Status: FotaStatusEnum[deviceStatus.Status],
          LastSegmentRequestTimestamp:
            deviceStatus.LastSegmentRequestTimestamp === emptyValueHyphen
              ? ""
              : deviceStatus.LastSegmentRequestTimestamp,
          TerminationType: TerminationTypeEnum[deviceStatus.TerminationType],
          TerminationDateTimestamp:
            deviceStatus.TerminationDateTimestamp === emptyValueHyphen
              ? ""
              : deviceStatus.TerminationDateTimestamp,
          TerminationReasonRemark:
            deviceStatus.TerminationReasonRemark === emptyValueHyphen
              ? ""
              : deviceStatus.TerminationReasonRemark,
        };
      }
    );
    const csv = Papa.unparse(deviceListToExport);
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download =
      moment(currentDate).format(DATE_TIME_FORMAT_FILENAME) +
      " DevicesFotaStatus.csv";
    document.body.appendChild(a);
    a.click();
    toast.success(formatMessage("download_started_successfully"));
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const abortAllDevicesPopupOpenHandler = () => {
    closePanelhandler();
    props.abortPopupToggleHandler();
  };

  const abortPopupOpenHandler = (
    row: IFotaDevicesStatusList,
    event: SyntheticEvent
  ) => {
    event.stopPropagation();
    closePanelhandler();
    setSelectedDevices([]);
    setSelectedId(row.Id);
    props.abortPopupToggleHandler();
  };

  /**
   * This function shows the delete user confirmation popup component and sets the seleted user Id
   */
  const deleteClickHandler = (row: { Id: number }, event: SyntheticEvent) => {
    event.stopPropagation();
    closePanelhandler();
    setSelectedDevices([]);
    setSelectedId(row.Id);
    props.confirmPopupToggleHandler();
  };


  const deleteAllDevicesPopupOpenHandler = () => {
    closePanelhandler();
    props.confirmPopupToggleHandler();
  };

  /**
   * This function deletes the user by providing Id to the Api
   */
  const deleteHandler = () => {
    //  setSelectedDevices([]);
    if (!selectedRecord?.Id) return;

    const selectedItem = getFotaSchedulerDeviceStatusList.find(item => item.Id === selectedId);
    if (!selectedItem?.ICCID) return;

    DeleteFotaDeviceScheduleService(selectedRecord.Id, [selectedItem.ICCID], isSelectedTabView);
  };


  const deleteSelectedDevicesHandler = () => {
    // setSelectedId(-1);
    if (selectedRecord?.Id)
      DeleteFotaDeviceScheduleService(selectedRecord?.Id,
        selectedDevices.map((device) => device.ICCID), isSelectedTabView
      );
  };

  const abortHandler = () => {
    if (!selectedRecord?.Id) return;

    const selectedItem = getFotaSchedulerDeviceStatusList.find(item => item.Id === selectedId);
    if (!selectedItem?.ICCID) return;

    AbortFotaDeviceScheduleByDeviceListService(selectedRecord.Id, [selectedItem.ICCID], isSelectedTabView);
  };

  const abortSelectedDevicesHandler = () => {
    // setSelectedId(-1);
    if (selectedRecord?.Id)
      AbortFotaDeviceScheduleByDeviceListService(selectedRecord?.Id,
        selectedDevices.map((device) => device.ICCID), isSelectedTabView
      );
  };
  const getFotaFileTypeHandler = (fileType: fotaFileTypeEnum) => {
    if (fileType == fotaFileTypeEnum.NoConvert) return formatMessage("no_convert");
    else if (fileType == fotaFileTypeEnum.ASCII) return formatMessage("ASCII");
    else return "";
  };
  const actionIcons: IActionFormatter[] = showIcons(
    [
      {
        dataField: "isDelete",
        handler: deleteClickHandler,
        icon: faTrashAlt,
        isDisable: true,
        title: "delete",
        action: "delete",
        varient: "danger",
      },
      {
        dataField: "isAbort",
        handler: abortPopupOpenHandler,
        icon: faBan,
        isDisable: true,
        title: "abort_schedule",
        varient: "primary",
      },
    ],
    systemModuleEnum.Fota
  );

  const columns: any = [
    {
      dataField: "Id",
      text: "label_id",
      hidden: true,
    },
    {
      dataField: "ICCID",
      text: formatMessage("iccid"),
    },
    {
      dataField: "TotalSegment",
      text: formatMessage("total_segment"),
      formatter: (cell: any, row: any) => {
        return (
          <span>
            {
              <span>
                {row?.LastSegmentNoRequestedByDevice}/{cell}
              </span>
            }
          </span>
        );
      },
    },
    {
      dataField: "LastSegmentRequestTimestamp",
      text: formatMessage("last_segment_timestamp"),
      formatter: (cell: any, row: any) => {
        return (
          <span>{cell}</span>
        );
      },
    },
    {
      dataField: "StatusValue",
      text: formatMessage("status"),
      formatter: (cell: number, row: any) => {
        return (<FormattedMessage id={cell} />);
      },
    },
    {
      dataField: "DeviceRebootedMessage",
      text: formatMessage("device_rebooted_message"),
    },
    {
      dataField: "",
      text: formatMessage("actions"),
      hidden: actionIcons.length === 0 ? true : false,
      // hidden: isSelectedTabView == fotaViewTypeEnum.Jet || isSelectedTabView == fotaViewTypeEnum.Modem ? true : false,
      formatter: (cell: any, row: IFotaDevicesStatusList) => {
        return (
          <>
            <div className="btn-group">
              {isOperationPermitted(systemModuleEnum.Fota, "Delete") && (
                <button
                  className={`btn btn-outline-primary btn-sm`}
                  key="delete"
                  title={formatMessage("delete")}
                  type="button"
                  disabled={!row.isDelete}
                  onClick={(event) => deleteClickHandler(row, event)}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </button>
              )}
              {isOperationPermitted(systemModuleEnum.Fota, "Edit") && (
                <button
                  className={`btn btn-outline-primary btn-sm`}
                  key="abort_schedule"
                  title={formatMessage((row.Status === FotaStatusEnum.Aborted) ? "device_aborted" : ((row.Status === FotaStatusEnum.Pending || row.Status === FotaStatusEnum.Success || row.Status === FotaStatusEnum.None || row.Status === FotaStatusEnum.Failed) ? "cant_abort" : "abort_schedule"))}
                  type="button"
                  disabled={!row.isAbort}
                  onClick={(event) => abortPopupOpenHandler(row, event)}
                >
                  {
                    (row.Status === FotaStatusEnum.Aborted) ?
                      <DisableAbortIconSVG /> :
                      ((row.Status === FotaStatusEnum.Pending || row.Status === FotaStatusEnum.Success || row.Status === FotaStatusEnum.None || row.Status === FotaStatusEnum.Failed) ?
                        <CantAbortIconSVG /> :
                        <AbortIconSVG />)
                  }
                </button>
              )}
            </div>
          </>
        );
      },
    },
  ];

  const openFilterPopUpHandler = () => {
    closePanelhandler();
    props.filterToggleHandler();
  };

  const closeFilterPopupHandler = () => {
    props.filterToggleHandler();
  };

  const filterSubmitHandler = (values: any) => {
    setSelectedDevices([]);
    closeFilterPopupHandler();
    setPageInfo({ ...pageInfo, currentPage: 1, isRefreshPage: true });
    setFilterDetail({ ...values, isFilterActive: true });
    closePanelhandler();
  };

  const resetFilter = () => {
    closePanelhandler();
    setFilterDetail({
      SearchBy: -1,
      ICCID: "",
      Status: 0,
      LastSegmentRequestTimestampStartDate: "",
      EnLastSegmentRequestTimestampEndDatedDate: "",
      DeviceRebootedMessage: "",
      isFilterActive: false,
    });
    setPageInfo({ ...pageInfo, currentPage: 1, isRefreshPage: true });
    setSelectedDevices([]);
  };

  function handleRowSelect(row: any, isSelect: any, rowIndex: any, e: any) {
    if (isSelect) {
      setSelectedDevices((prevState) => {
        const array: any = [...prevState];
        array.push(row);
        return array;
      });
    } else {
      setSelectedDevices((prevState) => {
        const array: any = [...prevState];
        let index = array.findIndex(
          (item: IFotaDevicesStatusList) => item.Id === row.Id
        );
        if (index > -1) array.splice(index, 1);
        return array;
      });
    }
  }

  function handleSelectAll(isSelect: any, rows: any, e: any) {
    if (isSelect) {
      setSelectedDevices((prevState) => {
        const array: any = [...prevState];
        rows.forEach((row: any) => {
          array.push(row);
        });
        return array;
      });
    } else {
      setSelectedDevices([]);
    }
  }

  const selectRow = {
    mode: "checkbox",
    selected: selectedDevices.map((device) => device.Id),
    onSelect: handleRowSelect,
    onSelectAll: handleSelectAll,
  };

  const abortPopupCloseHandler = () => {
    if (selectedId > 0)
      setSelectedId(-1);
    else
      setSelectedDevices([]);
    props.abortPopupToggleHandler();
  }

  const deletePopupCloseHandler = () => {
    if (selectedId > 0)
      setSelectedId(-1);
    else
      setSelectedDevices([]);
    props.confirmPopupToggleHandler();
  }


  const getSelectedTabEnumInString = () => {
    //[Deepak] will check why isSelectedView not able to set new view only for title case
    //  switch (isSelectedView.view) {
    //   case fotaViewTypeEnum.Host:
    //     return "host";
    //   case fotaViewTypeEnum.Modem:
    //     return "modem";
    //   case fotaViewTypeEnum.Jet:
    //     return "jet";
    //   default:
    //     return "host";
    // }

    //Get detail from history
    switch (isSelectedTabView) {
      case fotaViewTypeEnum.Host:
        return "host";
      case fotaViewTypeEnum.Modem:
        return "modem";
      case fotaViewTypeEnum.Jet:
        return "jet";
      default:
        return "host";
    }
  };

  return (
    <>
      {/*Aort confirm popup */}
      {props.showAbortPopup && (
        <DeletePopup
          title={
            selectedId > 0
              ? "abort_device_schedule_confirm"
              : "abort_selected_device_schedule_confirm"
          }
          modalSubmit={selectedId > 0 ? abortHandler : abortSelectedDevicesHandler}
          modalClosed={abortPopupCloseHandler}
          message={
            selectedId > 0
              ? "message_abort_device_schedule_confirm"
              : "message_abort_selected_device_schedule_confirm"
          }
          isLoading={abortSelectedDeviceScheduleState.inProgress}
        />
      )}
      {props.showConfirmPopup && (
        <DeletePopup
          title={
            selectedId > 0
              ? "delete_device_schedule"
              : "delete_selected_device_schedule"
          }
          modalSubmit={selectedId > 0 ? deleteHandler : deleteSelectedDevicesHandler}
          modalClosed={deletePopupCloseHandler}
          message={
            selectedId > 0
              ? "delete_device_schedule_confirm"
              : "delete_selected_device_schedule_confirm"
          }
          isLoading={deleteFotaDeviceScheduleState.inProgress}
        />
      )}
      {props.showFilterPopup && (
        <FotaDeviceStatusFilterForm
          initialValues={_.omit(filterDetails, ["isFilterActive"])}
          isFilterActive={filterDetails.isFilterActive}
          submitHandler={filterSubmitHandler}
          modalClosed={closeFilterPopupHandler}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div id="moveContent">
          <div className="container-fluid">
            <div className="row g-0  align-items-center">
              <div className="col-sm-8 col-12">
                <div className="filter-left-area ps-5">
                  <ul className="d-flex align-items-start mt-1">
                    <li title={formatMessage("back")}>
                      <button
                        role=""
                        className="btn btn-secondary"
                        onClick={setFotaTabTypeAndRoute}
                      >
                        <i className="fa fa-arrow-left"></i>
                      </button>
                    </li>
                    <li className="ms-2">
                      <p className="h5 mb-0 d-inline">
                        <FormattedMessage id="fota_device_status" />
                      </p>
                     
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-sm-4 col-12">
                <div className="add-list">
                  <ul className="d-flex align-items-center">
                    <li className="" title={formatMessage("refresh")}>
                      <LoaderIconButton
                        id="RefreshDevicesStatus"
                        onClick={() => refreshClickHandler()}
                        svg={
                          <svg
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-arrow-repeat m-0"
                            viewBox="0 0 16 16"
                          >
                            <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                            <path
                              fillRule="evenodd"
                              d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"
                            />
                          </svg>
                        }
                        className="mx-1"
                        variant="light"
                      />
                    </li>
                    {filterDetails.isFilterActive == true ? (
                      <li>
                        <button
                          data-testid="FilterButton"
                          className="btn btn-light mx-2"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          onClick={resetFilter}
                          title={formatMessage("reset_filter")}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            id="Layer_1"
                            x="0px"
                            y="0px"
                            width="20px"
                            height="20px"
                            viewBox="0 0 122.88 110.668"
                            enableBackground="new 0 0 122.88 110.668"
                          >
                            <g>
                              <path
                                fill="currentColor"
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M91.124,15.645c12.928,0,23.406,10.479,23.406,23.406 c0,12.927-10.479,23.406-23.406,23.406c-12.927,0-23.406-10.479-23.406-23.406C67.718,26.125,78.197,15.645,91.124,15.645 L91.124,15.645z M2.756,0h117.322c1.548,0,2.802,1.254,2.802,2.802c0,0.848-0.368,1.622-0.996,2.139l-10.667,13.556 c-1.405-1.375-2.95-2.607-4.614-3.672l6.628-9.22H9.43l37.975,46.171c0.59,0.516,0.958,1.254,0.958,2.102v49.148l21.056-9.623 V57.896c1.651,1.9,3.548,3.582,5.642,4.996v32.133c0,1.105-0.627,2.064-1.586,2.506l-26.476,12.758 c-1.327,0.773-3.023,0.332-3.798-1.033c-0.258-0.441-0.368-0.92-0.368-1.4V55.02L0.803,4.756c-1.07-1.106-1.07-2.839,0-3.945 C1.355,0.258,2.056,0,2.756,0L2.756,0z M96.93,28.282c1.328-1.349,3.489-1.355,4.825-0.013c1.335,1.342,1.341,3.524,0.013,4.872 l-5.829,5.914l5.836,5.919c1.317,1.338,1.299,3.506-0.04,4.843c-1.34,1.336-3.493,1.333-4.81-0.006l-5.797-5.878l-5.807,5.889 c-1.329,1.349-3.489,1.355-4.826,0.013c-1.335-1.342-1.341-3.523-0.013-4.872l5.83-5.913l-5.836-5.919 c-1.317-1.338-1.3-3.507,0.04-4.843c1.339-1.336,3.492-1.333,4.81,0.006l5.796,5.878L96.93,28.282L96.93,28.282z"
                              />
                            </g>
                          </svg>
                        </button>
                      </li>
                    ) : (
                      ""
                    )}
                    <li data-testid="Filter">
                      <div className="dropdown">
                        <button
                          data-testid="FilterButton"
                          className="btn btn-light mx-2"
                          type="button"
                          onClick={openFilterPopUpHandler}
                          title={formatMessage("filter")}
                        >
                          <svg
                            className="svg-icon"
                            width="20px"
                            height="20px"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M859.02 234.524l0.808-0.756 0.749-0.813c27.047-29.356 33.876-70.34 17.823-106.957-15.942-36.366-50.416-58.957-89.968-58.957H163.604c-38.83 0-73.043 22.012-89.29 57.444-16.361 35.683-10.632 76.301 14.949 106.004l0.97 1.126 280.311 266.85 2.032 312.074c0.107 16.502 13.517 29.805 29.995 29.805l0.2-0.001c16.568-0.107 29.912-13.626 29.804-30.194l-2.198-337.564-296.478-282.241c-9.526-11.758-11.426-26.933-5.044-40.851 6.446-14.059 19.437-22.452 34.75-22.452h624.828c15.6 0 28.69 8.616 35.017 23.047 6.31 14.391 3.924 29.831-6.354 41.497l-304.13 284.832 1.302 458.63c0.047 16.54 13.469 29.916 29.998 29.915h0.087c16.568-0.047 29.962-13.517 29.915-30.085L573.04 502.36l285.98-267.836z"
                              fill="currentColor"
                            />
                            <path
                              d="M657.265 595.287c0 16.498 13.499 29.997 29.997 29.997h243.897c16.498 0 29.997-13.498 29.997-29.997 0-16.498-13.499-29.997-29.997-29.997H687.262c-16.498 0-29.997 13.499-29.997 29.997z m273.894 138.882H687.262c-16.498 0-29.997 13.499-29.997 29.997s13.499 29.997 29.997 29.997h243.897c16.498 0 29.997-13.499 29.997-29.997 0-16.498-13.499-29.997-29.997-29.997z m0 168.878H687.262c-16.498 0-29.997 13.499-29.997 29.997s13.499 29.997 29.997 29.997h243.897c16.498 0 29.997-13.499 29.997-29.997 0-16.498-13.499-29.997-29.997-29.997z"
                              fill="currentColor"
                            />
                          </svg>
                        </button>
                      </div>
                    </li>
                    {isOperationPermitted(systemModuleEnum.Fota, "View") && (
                      <li
                        title={formatMessage("export_csv")}
                        className={`mx-2 ${getFotaSchedulerDeviceStatusList.length == 0
                          ? "disabled"
                          : ""
                          }`}
                      >
                        <LoaderButton
                          id="ExportAllDevicesStatus"
                          text="export_csv"
                          disabled={
                            getFotaSchedulerDeviceStatusList.length == 0
                          }
                          onClick={downloadCSVHandler}
                        />
                      </li>
                    )}
                    {
                      isOperationPermitted(systemModuleEnum.Fota, "Add") &&
                      <li>
                        <div className="dropdown">
                          <button
                            title={formatMessage("others")}
                            data-testid="BulkAction"
                            className="btn custom-select bulkActionButton"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {/* <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              className="bi bi-trash"
                              viewBox="0 0 20 20"
                            >
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                              <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                            </svg> */}
                            <FormattedMessage id={"others"} />
                          </button>
                          <ul className="dropdown-menu bulkaction-menu">
                            <li>
                              {selectedDevices.length > 0 ? (
                                <a
                                  data-testid="delete_selected"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                  onClick={deleteAllDevicesPopupOpenHandler}
                                  className="mx-2"
                                >
                                  <FormattedMessage id="delete_selected" />
                                </a>
                              ) : (
                                <span
                                  className="disabled_link"
                                  title={formatMessage("select_devices")}
                                >
                                  <FormattedMessage id="delete_selected" />
                                </span>
                              )}
                            </li>

                            <li>
                              {selectedDevices.length > 0 ? (
                                <a
                                  data-testid="abort_devices"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                  onClick={abortAllDevicesPopupOpenHandler}
                                  className="mx-2"
                                >
                                  <FormattedMessage id="abort_selected" />
                                </a>
                              ) : (
                                <span
                                  className="disabled_link"
                                  title={formatMessage("abort_selected_option")}
                                >
                                  <FormattedMessage id="abort_selected" />
                                </span>
                              )}
                            </li>
                          </ul>
                        </div>
                      </li>
                    }
                    {/* {isOperationPermitted(systemModuleEnum.Fota, "Add") && (
                      <li
                        title={formatMessage("abort_devices_schedule")}
                        className={`mx-2 ${
                          selectedDevices.some((device) => device.isAbort)
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <LoaderButton
                          id="ExportAllDevicesStatus"
                          text="abort_devices_schedule"
                          disabled={
                            !selectedDevices.some((device) => device.isAbort)
                          }
                          onClick={abortAllDevicesPopupOpenHandler}
                        />
                      </li>
                    )} */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="table_items_list">
        {schedulerDeviceStatusListState.inProgress && (
          <FormLoader loading={schedulerDeviceStatusListState.inProgress} />
        )}
         {selectedRecord?.Id && (
                        <small className="d-flex mt-2 flex-wrap gap-1 ">
                          <span >
                            <FormattedMessage id="fota_type" />:{" "}
                            {<FormattedMessage id={getSelectedTabEnumInString()} />}
                          </span>{" "}
                          |
                          {" "}
                          <span >
                            <FormattedMessage id="version" />:{" "}
                            {selectedRecord?.Version}
                          </span>{" "}
                          |
                          <span >
                            <FormattedMessage id="sending_method" />:{" "}
                            {getFotaFileTypeHandler(selectedRecord?.FileType)}
                          </span>{" "}
                          |
                          <span >
                            <FormattedMessage id="schedule_date" />:{" "}
                            {selectedRecord?.ScheduleDate}
                          </span>{" "}
                          |
                          <span >
                            <FormattedMessage id="schedule_expiration_date" />:{" "}
                            {selectedRecord?.ScheduleExpirationDate}
                          </span>
                        </small>
                      )}
        {getFotaSchedulerDeviceStatusList.length > 0 ? (
          <div
            className={`card mt-1 changingPanel ${openPanel ? "panelOpen" : ""
              }`}
          >
            <div className="tableDesign row-eq-height tableDevices ">
              <div className="table-responsive" data-testid="table">
                <Grid
                  data={getFotaSchedulerDeviceStatusList}
                  columns={columns}
                  keyField="Id"
                  loading={schedulerDeviceStatusListState.inProgress}
                  selectRow={selectRow}
                  rowEvents={selectedDevices.length === 0
                    ? { onClick: rowEvents }
                    : undefined}
                  rowClasses={rowClassFormat}
                />
              </div>
            </div>

            {getFotaSchedulerDeviceStatusList.length > 0 ? (
              <div className="row g-0 p-2 tableFooter">
                <div className="col-sm-6 pt-1">
                  <FormattedMessage id="show" />
                  <select
                    data-testid="pageSelect"
                    className="pageLimit"
                    onChange={onPageLimitChanged}
                    value={pageLimitInfo.pageLimit}
                  >
                    {pageLimitOptions.map((op: any) => (
                      <option key={op} value={op}>
                        {op}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-sm-6 d-flex justify-content-sm-end">
                  <Pagination
                    isRefreshPage={false}
                    totalPages={pageInfo.totalPages}
                    pageLimit={pageLimitInfo.pageLimit}
                    onPageChanged={onPageChanged}
                    disablePagination={disablePagination}
                    setIsRefreshPage={setIsRefreshPage}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div className="message text-center">
            <img src={no_user} alt="" className="no_message" />
            <p className="noData text-muted text-center h4 mb-0">
              <FormattedMessage id="no_device_scheduler_status" />
            </p>
            <p className="mb-3">
              {formatMessage(
                filterDetails.isFilterActive
                  ? "no_device_scheduler_status_after_filter_msg"
                  : "no_device_scheduler_status_msg"
              )}
            </p>
          </div>
        )}
      </div>
      <SlidingPanel
        type={"right"}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel order_details_panel">
          <div className="row bb p-2 g-0">
            <div className="col-lg-11">
              <h2 className="fw-bold mb-0 mt-2">
                {selectedRecord?.ScheduleDate}
              </h2>
            </div>
            <div className="col-lg-1 text-end">
              <button
                onClick={closePanelhandler}
                className="Crossicons"
                title={formatMessage("close")}
              >
                <svg
                  role="button"
                  xlinkTitle="close"
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  className="bi bi-x"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </button>
            </div>
          </div>
          <FotaDeviceStatusDetails selectedData={selectedRow} />
        </div>
      </SlidingPanel>
    </>
  );
};

export default ConfirmPopupHOC(
  AbortPopupHOC(FilterPopupHOC(observer(FotaSchedulerDeviceStatus)))
);
